import { HTTP_METHOD } from '@nxt-insurance/api-service'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_previous_insurer = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurer')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.previous_insurer.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_previous_insurer.title',
        },
      },
      {
        type: 'dropDown',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurer'),
        label: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_previous_insurer.label',
        },
        styleType: 'underlined',
        options: params.helperFunctions.getTransientPath('previousInsurers'),
        optionsTransformer: (insurers) =>
          insurers.map(
            (insurer): TransformedOption => ({
              value: insurer.toString(),
              label: {
                type: 'nonTranslatableText',
                text: insurer.toString(),
              },
            })
          ),
      },
    ],

    onPrepare: {
      type: 'simpleHook',
      callback: async () => {
        const response = await params.clientHelpers.apiService.call({
          serviceName: 'insurance',
          method: HTTP_METHOD.GET,
          url: `/api/v2/markets/${params.clientHelpers.getMarket()}/products/${
            params.productKey
          }/configuration_params_options`,
        })

        return {
          formValues: {
            [params.helperFunctions.getTransientPath('previousInsurers')]:
              response.data.previous_insurer,
          },
        }
      },
    },
    subFlow: params.subFlow,
    nextStep: 'pet_insurance_cancelled',
  }) as const satisfies AnyStepConfiguration

export default pet_previous_insurer
